export const localizationMessagesSelector = (state) => state.get('localization').get('messages');

export const currentUserLocaleSelector = (state) => state.get('localization').get('currentLocale');
